import * as e from "react";
const h = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TV_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TV_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#00B4FF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TV_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TV_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TV_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TV_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TV_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#TV_svg__d)"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.856 10.685l.608-1.125 1.332-.04-1.032-.861.356-1.163-.89.534-1.123-.681.109 1.291-1.008.605 1.308.164.34 1.276zm-3.392.875l-.608 1.125-.34-1.276-1.307-.164 1.007-.605-.11-1.291 1.125.681.889-.534-.356 1.163 1.032.861-1.332.04zm-2.608 3.125l.608-1.125 1.332-.04-1.032-.861.356-1.163-.89.534-1.123-.681.109 1.291-1.008.605 1.308.164.34 1.276zm-4 4l.608-1.125 1.332-.04-1.032-.861.356-1.163-.89.534-1.123-.681.109 1.291-1.008.605 1.308.164.34 1.276zm-3.882 3.051l-1.1.652.366-1.27-1.037-.813h1.175l.572-1.163.612 1.163H14.6l-.904.814.44 1.27-1.162-.653zm4.49-.176l-.608 1.125-.34-1.276-1.307-.164 1.007-.605-.11-1.291 1.125.681.889-.534-.356 1.163 1.032.861-1.332.04zm4-2l-.608 1.125-.34-1.276-1.307-.164 1.007-.605-.11-1.291 1.125.681.889-.534-.356 1.163 1.032.861-1.332.04zm4-2l-.608 1.125-.34-1.276-1.307-.164 1.007-.605-.11-1.291 1.125.681.889-.534-.356 1.163 1.032.861-1.332.04zm1.392-.875l.608-1.125 1.332-.04-1.032-.861.356-1.163-.89.534-1.123-.681.109 1.291-1.008.605 1.308.164.34 1.276z",
      fill: "#FFD018"
    }
  )))
), t = h;
export {
  t as default
};
